import FeedbackError from '../../components/atoms/feedbacks/feedback-error'
import SendGiftButtons from '../../components/organism/orders/send-gift-buttons.vue'
import PageHeadlineWithFourSteps from '../../components/molecules/headlines/PageHeadlineWithFourSteps'
import AccountIconWh80 from '../../components/atoms/account_icons/AccountIconWh80'

export default {
  components: {
    FeedbackError,
    SendGiftButtons,
    PageHeadlineWithFourSteps,
    AccountIconWh80
  },
  data() {
    return {
      isShowableError: false,
      errorMessage: '',
      flowLineContents: {
        steps: ['作成', 'プレビュー', '確認', '完了'],
        activeStep: 4
      }
    }
  },
  methods: {
    enterError() {
      setTimeout(() => {
        this.isShowableError = false
      }, 3000)
    },
    onClickBackToTop() {
      window.location.href = '/'
    },
    onClickBackWishList(path) {
      window.location.href = path
    }
  }
}
